import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Lightbox from 'react-images';
import { Image, MultipleImages } from '@bufferapp/components';
import { grayLighter, gray } from '@bufferapp/ui/style/colors';
import { borderRadius } from '@bufferapp/ui/style/borders';

import IdTag from '../IdTag';

const MediaWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9rem;
  height: ${(props) =>
    props.profileService === 'tiktok' || props.profileService === 'youtube'
      ? '16rem'
      : '9rem'};
  border-radius: ${borderRadius};
  border: 1px solid ${gray};
  background: ${grayLighter};
`;

const ThumbnailTag = styled.span`
  position: absolute;
  bottom: 0.7rem;
  left: 0.7rem;
`;

const UpdateMediaContent = ({
  imageSrc,
  videoSrc,
  imageUrls,
  type,
  profileService,
  isReelPost,
  isStoryPost,
}) => {
  // State
  const [isLightboxOpen, openLightbox] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const isVideo = type === 'video';
  const isMultipleImage = type === 'multipleImage';
  const isSingleImage = type === 'image' || isVideo;
  const imageArray = isMultipleImage ? imageUrls : [imageSrc];
  const images = imageArray?.map((url) => ({ src: `${url}` }));

  const shouldIncreaseHeight =
    profileService === 'tiktok' || profileService === 'youtube';

  return (
    <MediaWrapper
      onClick={() => {
        if (isVideo && videoSrc) {
          window.open(videoSrc, '_blank');
        } else {
          openLightbox(true);
          setCurrentImage(0);
        }
      }}
    >
      {isMultipleImage && (
        <MultipleImages
          border="rounded"
          height="9rem"
          urls={imageUrls}
          width="9rem"
        />
      )}
      {isSingleImage && (
        <ImageWrapper profileService={profileService}>
          <Image
            src={imageSrc}
            width="auto"
            height="auto"
            maxWidth="9rem"
            maxHeight={shouldIncreaseHeight ? '16rem' : '9rem'}
            minHeight="7rem"
            minWidth="7rem"
            objectFit="cover"
          />
        </ImageWrapper>
      )}
      <Lightbox
        images={images}
        isOpen={isLightboxOpen}
        onClickPrev={() => {
          setCurrentImage(currentImage - 1);
        }}
        onClickNext={() => {
          setCurrentImage(currentImage + 1);
        }}
        onClose={() => {
          openLightbox(false);
        }}
        currentImage={currentImage}
        backdropClosesModal
        showImageCount={false}
      />
      {isVideo && isReelPost && (
        <ThumbnailTag>
          <IdTag>Reel</IdTag>
        </ThumbnailTag>
      )}
      {isVideo && !isReelPost && !isStoryPost && (
        <ThumbnailTag>
          <IdTag>Video</IdTag>
        </ThumbnailTag>
      )}
      {isStoryPost && (
        <ThumbnailTag>
          <IdTag>Story</IdTag>
        </ThumbnailTag>
      )}
    </MediaWrapper>
  );
};

UpdateMediaContent.propTypes = {
  type: PropTypes.oneOf(['text', 'image', 'multipleImage', 'link', 'video'])
    .isRequired,
  imageSrc: PropTypes.string,
  videoSrc: PropTypes.string,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  profileService: PropTypes.string,
  isReelPost: PropTypes.bool,
  isStoryPost: PropTypes.bool,
};

UpdateMediaContent.defaultProps = {
  imageSrc: '',
  videoSrc: '',
  imageUrls: [],
  profileService: '',
  isReelPost: false,
  isStoryPost: false,
};

export default UpdateMediaContent;
